import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    leaveData: [], 
}

const userLeaveSlice = createSlice({
  name: "userLeave",
  initialState: initialState,
  reducers: {
    setUserLeaveData(state, value) {
      state.leaveData = value.payload;
    }
  },
});

export const { setUserLeaveData } = userLeaveSlice.actions;

export default userLeaveSlice.reducer;